var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCuradoria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.717 9.795l-2.865.61 1.94 2.19-1.696 1.257-1.51-2.533-1.508 2.533-1.728-1.256 1.912-2.13-2.866-.67.647-2.011 2.652 1.149L4.48 6.01H6.63l-.338 2.872L9.04 7.752l.678 2.043zM11.111 20V0H0v20l5.555-5.556L11.11 20z",
    fill: "#21C5E5"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzE2OTYgOS43OTUzNkw2Ljg1MTc4IDEwLjQwNDNMOC43OTE0IDEyLjU5NTdMNy4wOTU1IDEzLjg1MjJMNS41ODY3NSAxMS4zMTlMNC4wNzc5OSAxMy44NTIyTDIuMzUwMTggMTIuNTk1N0w0LjI2MjIzIDEwLjQ2NkwxLjM5NTYgOS43OTUzNkwyLjA0MjYyIDcuNzg0ODhMNC42OTQ1NSA4LjkzMzczTDQuNDc5ODQgNi4wMTEzNEg2LjYzMTI3TDYuMjkzMjUgOC44ODM0Nkw5LjAzOTQ3IDcuNzUxODVMOS43MTY5NiA5Ljc5NTM2Wk0xMS4xMTExIDIwVjBIMFYyMEw1LjU1NDgzIDE0LjQ0MzlMMTEuMTExMSAyMFoiIGZpbGw9IiMyMUM1RTUiLz4KPC9zdmc+Cg==";
export { SvgIconCuradoria as ReactComponent };